/* eslint-disable max-len */
/* eslint-disable func-names */
import React from 'react';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { Label } from 'rbx';
import styled from 'styled-components';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { isNaN } from 'lodash';
import moment from 'moment-timezone';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useStoreState } from 'easy-peasy';

import client from '../../../utils/apolloClient';
import Layout from '../../../components/global/Layout';
import Header from './Header';
import TablebookingStats from './TablebookingStats';
import {
  CheckBox,
  Select,
  TextArea,
  // InputErrorMessage,
} from '../../../components/elements';
// import Toggle from './Toggle';
// import Billing from './Billing';
import Footer from './Footer';
import RefundStats from './RefundStats';
import cancellationReasons from '../CancelBooking/cancellationReasons';

const getRefundImpactMutation = gql`
  mutation getRefundImpactMutation($input: GetRefundImpactInput) {
    get_refund_impact(input: $input) {
      refund_impact
    }
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 75vw;
  align-items: start;
`;

const BookingDetailsItem = styled.div`
  display: grid;
  grid-template-columns: 0.75fr 1.25fr;
  width: 100%;
  gap: 2rem 0;
  padding: 2rem;
`;

const RefundFormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 2rem;
  padding: 2rem;
`;

const GridItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 2rem;
  padding: 2rem;
`;

const GridItem2 = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 2rem;
  padding: 0 2rem;
`;

const GridItem3 = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 0;
  padding: 0 2rem;
`;

const LeftSpan = styled.span`
  color: #737373;
`;

const RightSpan = styled.span`
  font-weight: 700;
`;

export const Legend = styled.div`
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 20px;

  h3 {
    margin-top: 0;
    color: #856404;
  }

  ul {
    list-style: disc;
    list-style-position: inside;
    margin: 10px 0;
  }

  li {
    margin: 5px 0;
  }
`;

const Form = props => {
  const {
    setFieldValue,
    values,
    handleSubmit,
    // touched,
    errors,
    history,
    cancelBookingFormProps,
    isSubmitting,
    validateForm,
  } = props;

  const {
    tableBookingData,
    tableSetting,
    place,
    charges,
  } = cancelBookingFormProps;

  const { userId: adminUserId, user } = useStoreState(state => state.auth);

  const [getRefundImpact, { loading: refundImpactLoading }] = useMutation(
    getRefundImpactMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ get_refund_impact }) => {
        if (get_refund_impact?.refund_impact) {
          setFieldValue('refundImpact', get_refund_impact?.refund_impact);
        }
      },
      onError: error => {
        console.log(error);
      },
    },
  );

  const partnerRoleOfUser =
    user?.role && Array.isArray(user?.role)
      ? user.role.find(ele => ele.startsWith('partner'))
      : '';

  const superAdminValue =
    user?.role && Array.isArray(user?.role)
      ? user.role.find(ele => ele === 'kravein_super_admin')
      : '';

  const kraveinRoleOfUser =
    user?.role && Array.isArray(user?.role)
      ? user.role.find(ele => ele.startsWith('kravein'))
      : '';

  let userRole = '';

  if (partnerRoleOfUser) {
    userRole = partnerRoleOfUser;
  }

  if (kraveinRoleOfUser) {
    userRole = kraveinRoleOfUser;
  }

  if (superAdminValue) {
    userRole = superAdminValue;
  }

  React.useEffect(() => {
    if (values.paymentCaptured) {
      getRefundImpact({
        variables: {
          input: {
            user_id: adminUserId,
            table_booking_id: tableBookingData.table_booking_id,
            reverse_transfer: values.reverse_transfer,
            refund_application_fee: values.refund_application_fee,
            refund_amount: Number(values.refund_amount || 0),
            user_role: userRole,
          },
        },
      });
    }
  }, [
    tableBookingData.table_booking_id,
    adminUserId,
    values.reverse_transfer,
    values.refund_application_fee,
    values.refund_amount,
    values.paymentCaptured,
    userRole,
  ]);

  React.useEffect(() => {
    console.log('setting timezone =', place?.timezone);
    moment.tz.setDefault(place?.timezone);
  }, [place?.timezone]);

  return (
    <Layout>
      <form
        onSubmit={async e => {
          e.preventDefault();

          const calculatedErrors = await validateForm();
          const temp = Object.values(calculatedErrors);

          if (Array.isArray(temp) && temp[0]) {
            try {
              handleSubmit();
            } catch {
              // pass
            }

            swal({
              title: 'Error',
              text: temp[0],
              icon: 'warning',
              buttons: true,
              dangerMode: true,
            });
          } else {
            handleSubmit();
          }
        }}
      >
        <Header
          history={history}
          place={place}
          isSubmitting={isSubmitting}
          bookingReference={tableBookingData?.booking_reference}
          bookingStatus={tableBookingData?.booking_status}
          // hideSubmit={!charges?.eligible_refund}
        />
        <TablebookingStats
          guestName={`${tableBookingData?.contact?.first_name} ${tableBookingData?.contact?.last_name}`}
          guests={`${tableBookingData?.guest_count} ${
            tableBookingData?.guest_count > 1 ? 'Guests' : 'Guest'
          }`}
          date={tableBookingData?.booking_date}
          time={tableBookingData?.booking_time}
        >
          <span>
            {tableBookingData?.contact?.contact_email}
            <span style={{ fontSize: '12px', fontWeight: '400' }}>
              &nbsp;({tableBookingData?.contact?.contact_phone})
            </span>
          </span>
        </TablebookingStats>
        <div className="m-6">
          <Legend>
            <h3>Refund Guidelines</h3>
            <ul>
              <li>
                To debit the order value from the restaurant including Kravein
                fee and credit card charge check the &apos;Refund from
                Restaurant&apos; checkbox only.
              </li>
              <li>
                To debit the order value only from the restaurant and Kravein
                fee / credit card charge from kravein account tick both the
                checkboxes.
              </li>
              <li>
                To debit the order value including Kravein fee and credit card
                charge from kravein account do not tick any boxes.
              </li>
            </ul>
          </Legend>
          <GridContainer>
            <RefundFormContainer>
              {!charges?.eligible_refund && (
                <>
                  <p className="help is-danger is-size-4">
                    The guest is not eligible for a refund based on this
                    reservation&apos;s cancellation policy. As an Admin you can
                    refund this booking if you wish to refund the customer.
                  </p>
                </>
              )}
              <div>
                <div style={{ display: 'flex' }}>
                  <LeftSpan className="is-flex">
                    Refund Amount
                    <span className="help is-danger is-size-4">*</span>
                  </LeftSpan>
                  <div
                    className="field"
                    style={{
                      paddingLeft: '10px',
                      position: 'relative',
                      bottom: '5px',
                    }}
                  >
                    <p className="control has-icons-left">
                      <input
                        value={values.refund_amount}
                        className="input is-primary"
                        type="number"
                        placeholder="0.00"
                        style={{ width: '100px' }}
                        onChange={e => {
                          if (e.target.value > values.totalAmountPaid) {
                            // eslint-disable-next-line no-alert
                            alert(
                              `Refund amount cannot be greater than $${parseFloat(
                                values.totalAmountPaid,
                              ).toFixed(2)}`,
                            );
                            setFieldValue('refund_amount', '');
                            return;
                          }

                          if (e.target.value < 0) {
                            // eslint-disable-next-line no-alert
                            alert(
                              'The input value must be greater than or equal to 0!',
                            );
                            setFieldValue('refund_amount', '');
                            return;
                          }

                          if (
                            e.target.value !== '' &&
                            isNaN(parseFloat(e.target.value))
                          ) {
                            // eslint-disable-next-line no-alert
                            alert('The input value must be a valid number!');
                            setFieldValue('refund_amount', '');
                            return;
                          }

                          if (e.target.value === '') {
                            setFieldValue('refund_amount', '');
                          } else {
                            setFieldValue(
                              'refund_amount',
                              parseFloat(e.target.value),
                            );
                          }
                        }}
                      />
                      <span className="icon is-small is-left">$</span>
                    </p>
                  </div>
                </div>
                {errors.refund_amount && (
                  <p className="help is-danger is-size-4">
                    {errors.refund_amount}
                  </p>
                )}
              </div>
              <div>
                <div style={{ display: 'flex' }}>
                  <LeftSpan className="is-flex">
                    Balance Total
                    <span className="help is-danger is-size-4">*</span>
                  </LeftSpan>
                  <div
                    className="field"
                    style={{
                      paddingLeft: '10px',
                      position: 'relative',
                      bottom: '5px',
                    }}
                  >
                    <p className="control has-icons-left">
                      <input
                        className="input is-primary"
                        type="number"
                        placeholder="0.00"
                        style={{ width: '100px' }}
                        value={parseFloat(
                          values.totalAmountPaid -
                            values.refund_amount -
                            values.totalRefund,
                        ).toFixed(2)}
                        disabled
                      />
                      <span className="icon is-small is-left">$</span>
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <Select
                  label="Reason"
                  options={[
                    cancellationReasons.DUPLICATE,
                    cancellationReasons.FRAUDULENT,
                    cancellationReasons.REQUESTED_BY_CUSTOMER,
                    cancellationReasons.OTHER,
                  ]}
                  value={[
                    {
                      label:
                        cancellationReasons[values.refund_reason]?.label || '',
                      value:
                        cancellationReasons[values.refund_reason]?.value || '',
                    },
                  ]}
                  onChange={({ value }) =>
                    setFieldValue('refund_reason', value)
                  }
                  required
                />
                {errors.refund_reason && (
                  <p className="help is-danger is-size-4">
                    {errors.refund_reason}
                  </p>
                )}
              </div>
              <div>
                <CheckBox
                  label="Refund From Restaurant"
                  name="reverse_transfer"
                  value={values.reverse_transfer}
                  onChange={() => {
                    if (
                      !values.reverse_transfer === false &&
                      values.refund_application_fee === false
                    ) {
                      // both unchecked scenario
                      swal({
                        title: `The funds will be debited from the Kravein Account. Are you sure you want to proceed?`,
                        text: `To debit the order value from the restaurant including Kravein fee and credit card charge check the 'Refund from Restaurant' checkbox only.To debit the order value only from the restaurant and Kravein fee / credit card charge from  kravein account tick both the checkboxes.`,
                        buttons: ['No', 'Yes'],
                      }).then(yes => {
                        if (yes) {
                          setFieldValue(
                            'reverse_transfer',
                            !values.reverse_transfer,
                          );
                        }
                      });
                    } else {
                      setFieldValue(
                        'reverse_transfer',
                        !values.reverse_transfer,
                      );
                    }
                  }}
                  disabled={
                    values.hasAlreadyRefunded || values.refund_application_fee
                  }
                />
                <CheckBox
                  label="Refund Kravein Fee"
                  name="refund_application_fee"
                  value={values.refund_application_fee}
                  onChange={() => {
                    if (!values.refund_application_fee === false) {
                      // both unchecked scenario
                      swal({
                        title: `The funds will be debited from the Kravein Account. Are you sure you want to proceed?`,
                        text: `To debit the order value from the restaurant including Kravein fee and credit card charge check the 'Refund from Restaurant' checkbox only.To debit the order value only from the restaurant and Kravein fee / credit card charge from  kravein account tick both the checkboxes.`,
                        buttons: ['No', 'Yes'],
                      }).then(yes => {
                        if (yes) {
                          setFieldValue(
                            'refund_application_fee',
                            !values.refund_application_fee,
                          );
                          setFieldValue(
                            'reverse_transfer',
                            !values.refund_application_fee,
                          );
                        }
                      });
                    } else if (!values.refund_application_fee === true) {
                      // both checked scenario
                      swal({
                        text: `Are you sure you want to debit Kravein fee and credit card charge from Kravein account and not from the restaurant?`,
                        buttons: ['No', 'Yes'],
                      }).then(yes => {
                        if (yes) {
                          setFieldValue(
                            'refund_application_fee',
                            !values.refund_application_fee,
                          );
                          setFieldValue(
                            'reverse_transfer',
                            !values.refund_application_fee,
                          );
                        }
                      });
                    }
                  }}
                  disabled={values.hasAlreadyRefunded}
                />
              </div>
              <div>
                <TextArea
                  required
                  label="Refund Notes"
                  name="Refund Notes"
                  // optionalText="(Min 10 and Max 8000 Characters)"
                  placeholder="Add more details about this refund"
                  value={values.note}
                  onChange={e => setFieldValue('note', e.target.value)}
                />
                {errors.note && (
                  <p className="help is-danger is-size-4">{errors.note}</p>
                )}
              </div>
              <div>
                <div className="is-flex">
                  <LeftSpan className="is-flex">
                    Approval Code
                    <span className="help is-danger is-size-4">*</span>
                  </LeftSpan>
                  <div style={{ paddingLeft: '15px' }}>
                    <input
                      className="input is-primary"
                      type="text"
                      placeholder="XXXXXXX"
                      style={{ width: '100px' }}
                      onChange={e => {
                        setFieldValue('approval_code', e.target.value);
                      }}
                    />
                  </div>
                </div>
                {errors.approval_code && (
                  <p className="help is-danger is-size-4">
                    {errors.approval_code}
                  </p>
                )}
              </div>
            </RefundFormContainer>
            <fieldset className="box">
              <BookingDetailsItem>
                <LeftSpan>Customer Details</LeftSpan>
                <RightSpan>
                  {tableBookingData?.contact?.contact_email}
                  <span style={{ fontSize: '12px', fontWeight: '400' }}>
                    &nbsp;({tableBookingData?.contact?.contact_phone})
                  </span>
                </RightSpan>
                <LeftSpan>Booking ID</LeftSpan>
                <RightSpan>{tableBookingData?.booking_reference}</RightSpan>
                <LeftSpan>Booking Total</LeftSpan>
                <RightSpan>
                  $
                  {parseFloat(tableBookingData?.billing?.booking_total).toFixed(
                    2,
                  )}
                </RightSpan>
                <LeftSpan>Refund Total</LeftSpan>
                <RightSpan>
                  ${parseFloat(values.totalRefund).toFixed(2)}
                </RightSpan>
                <LeftSpan>Cancellation Charge</LeftSpan>
                <RightSpan>
                  ${parseFloat(charges?.cancellation_charges).toFixed(2)}
                </RightSpan>
                <LeftSpan>Refund Impact</LeftSpan>
                {refundImpactLoading ? (
                  <span>...</span>
                ) : (
                  <span className="help is-danger is-size-4">
                    {values.paymentCaptured
                      ? values.refundImpact
                      : "Refund impact can't be calculated before the payment is captured."}
                  </span>
                )}
              </BookingDetailsItem>
              <GridItem2>
                <Label>Payment Details</Label>
              </GridItem2>
              <BookingDetailsItem>
                {tableBookingData?.billing?.sub_total && (
                  <>
                    <LeftSpan>
                      Deposit{' '}
                      {tableBookingData?.guest_count &&
                      tableSetting?.booking_fee?.booking_fee_info
                        ?.booking_deposit &&
                      tableSetting?.booking_fee?.booking_fee_info
                        ?.booking_type === 'FEE_PER_GUEST'
                        ? ` ($${parseFloat(
                            tableSetting?.booking_fee?.booking_fee_info
                              ?.booking_deposit,
                          )} x ${tableBookingData?.guest_count})`
                        : ''}
                    </LeftSpan>
                    <RightSpan>
                      $
                      {parseFloat(tableBookingData?.billing?.sub_total).toFixed(
                        2,
                      )}
                    </RightSpan>
                  </>
                )}
                {tableBookingData?.billing?.sub_total && (
                  <>
                    <LeftSpan>Subtotal</LeftSpan>
                    <RightSpan>
                      $
                      {parseFloat(tableBookingData?.billing?.sub_total).toFixed(
                        2,
                      )}
                    </RightSpan>
                  </>
                )}
                {Array.isArray(tableBookingData?.billing?.charges_list) &&
                  tableBookingData?.billing?.charges_list
                    .filter(
                      chg =>
                        !chg.is_payment_gateway_fee &&
                        chg.is_payment_gateway_fee !== null,
                    )
                    .filter(chg => {
                      const tempValue = parseFloat(chg.value);
                      return tempValue !== 0 && !isNaN(tempValue);
                    })
                    .map(chg => (
                      <React.Fragment key={chg.name}>
                        <LeftSpan>{chg.name}</LeftSpan>
                        <RightSpan>
                          ${parseFloat(chg.value).toFixed(2)}
                        </RightSpan>
                      </React.Fragment>
                    ))}
                {!!tableBookingData?.billing?.payment_gateway_fee && (
                  <>
                    <LeftSpan>Card Processing Fee</LeftSpan>
                    <RightSpan>
                      $
                      {parseFloat(
                        tableBookingData?.billing?.payment_gateway_fee,
                      ).toFixed(2)}
                    </RightSpan>
                  </>
                )}
                <LeftSpan>Booking Total</LeftSpan>
                <RightSpan>
                  $
                  {parseFloat(tableBookingData?.billing?.booking_total).toFixed(
                    2,
                  )}
                </RightSpan>
              </BookingDetailsItem>
              {tableBookingData?.payment?.payment_at &&
                tableBookingData?.payment?.payment_card?.brand &&
                tableBookingData?.payment?.payment_card?.last4 && (
                  <GridItem3>
                    <p className="is-size-4 has-text-weight-semibold">
                      Paid: $
                      {parseFloat(
                        tableBookingData?.billing?.booking_total,
                      ).toFixed(2)}{' '}
                      on{' '}
                      {moment(tableBookingData?.payment?.payment_at).format(
                        'ddd, MMM DD, YYYY hh:mm A',
                      )}
                    </p>
                    <p>
                      {tableBookingData?.payment?.payment_card?.brand} ending in{' '}
                      {tableBookingData?.payment?.payment_card?.last4}
                    </p>
                  </GridItem3>
                )}
              <GridItem>
                <div>
                  <LeftSpan>
                    <Label>Refunds</Label>
                  </LeftSpan>
                  <RefundStats stats={values.refundSummary} />
                </div>
              </GridItem>
            </fieldset>
          </GridContainer>
        </div>
        <Footer
          isSubmitting={isSubmitting}
          // hideSubmit={!charges?.eligible_refund}
        />
      </form>
    </Layout>
  );
};

const transformRefundAmount = val => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : Math.abs(num);
};

const CancelBookingForm = withFormik({
  mapPropsToValues: ({ cancelBookingFormProps }) => {
    const {
      tableBookingData,
      // tableSetting,
      charges,
    } = cancelBookingFormProps;

    const totalAmountPaid = tableBookingData?.billing?.booking_total;
    const collectBookingFee = !!tableBookingData?.billing?.booking_total;

    const refundsDetails =
      tableBookingData?.payment?.refunds_details &&
      Array.isArray(tableBookingData?.payment?.refunds_details)
        ? tableBookingData?.payment?.refunds_details
        : [];

    let totalRefund = 0;
    const refundSummary = [];

    refundsDetails.forEach(ele => {
      const ra = transformRefundAmount(ele.refund_amount);
      totalRefund += ra;

      const temp = {
        userId: ele.attempted_by,
        refundAmount: ra,
        refundType: ele.refund_type,
        refundedAt: ele.refunded_at,
        status: ele.status,
        refundReason: ele.refund_reason,
        note: ele.note,
      };

      refundSummary.push(temp);
    });

    const hasAlreadyRefunded = !(totalRefund === 0);

    let refundableAmount = 0;

    if (hasAlreadyRefunded) {
      refundableAmount = totalAmountPaid - totalRefund;
    } else {
      refundableAmount = totalAmountPaid - charges?.cancellation_charges;
    }

    refundableAmount = parseFloat(refundableAmount ?? 0).toFixed(2);

    const refundImpact =
      tableBookingData?.payment?.refund_disbursement?.refund_impact || '';

    const paymentCaptured =
      tableBookingData?.payment?.payment_state === 'CAPTURED';

    return {
      note: '',
      refund_reason: '',
      approval_code: '',
      refund_amount: collectBookingFee ? refundableAmount : '',
      totalAmountPaid,
      collectBookingFee,
      refund_application_fee: tableBookingData?.refund_application_fee || false,
      reverse_transfer: tableBookingData?.reverse_transfer || true,
      totalRefund,
      refundSummary,
      hasAlreadyRefunded,
      refundImpact,
      paymentCaptured,
    };
  },

  validationSchema: yup.object().shape({
    refund_reason: yup.string().required('Refund reason is required!'),
    note: yup.string().required('Note is required!'),
    refund_application_fee: yup.boolean(),
    reverse_transfer: yup.boolean(),
    approval_code: yup
      .string()
      .required('Please enter your approval code!')
      .oneOf(['12345678'], 'Please enter the correct approval code!'),
    refund_amount: yup
      .number()
      .required('Refund amount is required!')
      .test(
        'not-empty-string',
        'Refund amount is required!',
        value => value !== '',
      ),
  }),

  handleSubmit: async (values, { props }) => {
    const {
      tableBookingData,
      updateTableBooking,
      userId,
      userRole,
    } = props.cancelBookingFormProps;

    const { history } = props;

    const input = {
      table_booking_id: tableBookingData.table_booking_id,
      action: 'REFUND',
      user_id: userId,
      refund_reason: values.refund_reason,
      refund_amount: values.refund_amount,
      approval_code: values.approval_code,
      refund_application_fee: values.refund_application_fee,
      reverse_transfer: values.reverse_transfer,
      user_role: userRole,
      note: values.note,
    };

    const res = await updateTableBooking.func(input);

    if (!res) {
      swal('Successfully refunded table booking').then(() => {
        history.go(0);
      });
    } else {
      toast.error(res);
    }
  },
  validateOnBlur: false,
  validateOnChange: false,
  enableReinitialize: true,
  displayName: 'CancelBookingForm',
})(Form);

export default CancelBookingForm;
